import { pageUrl } from '@/constants/url'
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const NotificationsPage = lazy(() => import('./pages/notificationsPage'))

export const notificationsRoutes = () => {
  return (
    <>
      <Route path={pageUrl.notifications} element={<NotificationsPage />} />
    </>
  )
}
